class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.hasEnded = false;
    this.endDate = this.parseEndDate();
    this.initializeElements();

    if (!this.endDate) {
      console.warn('CountdownTimer needs an end date');
      return;
    }

    this.setTimer();
  }

  connectedCallback() {
  }

  disconnectedCallback() {
    console.log('Custom element removed from page.');
  }

  parseEndDate() {
    let endDateString = this.dataset.endDate;

    // convert to date GMT-4
    endDateString = new Date(endDateString);
    endDateString = endDateString.toLocaleString('en-US', { timeZone: 'America/New_York' });
    endDateString = new Date(endDateString);

    return endDateString ? new Date(endDateString).getTime() : null;
  }

  initializeElements() {
    this.daysElement = this.querySelector('days');
    this.hoursElement = this.querySelector('hours');
    this.minutesElement = this.querySelector('minutes');
    this.secondsElement = this.querySelector('seconds');
    this.activeContentElements = this.querySelectorAll('active-content');
    this.endContentElements = this.querySelectorAll('ended-content');
  }

  showContent() {
    for (let i = 0; i < this.activeContentElements.length; i++) {
      this.activeContentElements[i].style.display = this.hasEnded ? 'none' : 'flex';
    }

    for (let i = 0; i < this.endContentElements.length; i++) {
      this.endContentElements[i].style.display = this.hasEnded ? 'flex' : 'none';
    }

    if (this.hasEnded) {
      this.ended();
    }
  }

  ended() {
    // an override method for classes that extend this class
  }

  setTimerStatus() {
    const now = new Date().getTime();
    let diff = this.endDate - now;
    this.hasEnded = diff < 0;
  }

  setTimer() {
    const timer = () => {
      if (typeof this.endDate !== 'number') return;

      const now = new Date().getTime();
      let diff = this.endDate - now;
      this.hasEnded = diff < 0;
      this.showContent();

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      // if timer has ended end timer
      if (diff < 0) {
        clearInterval(timer);
        this.updateElement(this.daysElement, '00');
        this.updateElement(this.hoursElement, '00');
        this.updateElement(this.minutesElement, '00');
        this.updateElement(this.secondsElement, '00', true);
      } else {
        this.updateElement(this.daysElement, days);
        this.updateElement(this.hoursElement, hours);
        this.updateElement(this.minutesElement, minutes);
        this.updateElement(this.secondsElement, seconds, true);
      }

      this.style.display = 'flex';
    };

    timer();
    // Run function every second.
    setInterval(timer, 1000);
  }

  updateElement(element, value, alwaysShow = false) {
    if (!element || !element.parentElement) return;

    element.parentElement.style.display = Math.round(value) > 0 || alwaysShow ? 'flex' : 'none';
    element.innerHTML = this.formatDigits(value);
  }

  formatDigits(value) {
    // Adding leading zeros.
    const zeroPad = (num, places) => String(num).padStart(places, '0');
    const values = zeroPad(value, 2).split('');
    const digits = values.map(val => `<digit>${val}</digit>`).join('');
    return `<digits>${digits}</digits>`;
  }
}

customElements.define('countdown-timer', CountdownTimer);
